import "./insEsgRatingKPIWidget.scss";
import { AuxIcon } from "@blk/aladdin-react-components-es";
import React from "react";
import { InsWidget, InsWidgetTitle } from "../../base";
import { InsEsgRatingKPIChart } from "./insEsgRatingKPIChart";
import { NARating } from "common/esg-helpers";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
export const InsEsgRatingKPIWidget = (props) => {
    const { sectionId, widgetId } = props, [result, queryState] = useGetDatapointsWidgetData(props), [newResult] = result?.[0]?.data || [];
    const currentValue = newResult?.variation?.current?.value ?? NARating;
    const previousValue = newResult?.variation?.previous?.value ?? NARating;
    const difference = newResult?.variation?.change;
    let variationElement = React.createElement("span", { className: "ins-esg-kpi-change-indicator--no-change" }, language.en.widgets.esgRating.noChangeSinceLastQuarter);
    if (currentValue === NARating || previousValue === NARating) {
        variationElement = React.createElement(React.Fragment, null);
    }
    else if (difference !== 0) {
        variationElement =
            React.createElement("span", { className: "ins-esg-kpi-change-indicator" },
                React.createElement(AuxIcon, { state: "primary", type: ((difference || 0) > 0 ? "arrow-dropdown-up" : "arrow-dropdown") }),
                previousValue,
                " ",
                language.en.widgets.esgRating.previousQuarter);
    }
    const content = currentValue
        ? React.createElement("div", { className: "ins-esg-kpi-widget-content small" },
            React.createElement(InsEsgRatingKPIChart, { selectedValue: currentValue || "", sectionId: sectionId, widgetId: widgetId }),
            React.createElement("div", { className: "ins-esg-kpi-variation" }, variationElement))
        : React.createElement(React.Fragment, null);
    return React.createElement("div", { className: "ins-kpi-widget ins-kpi-esg-rating" },
        React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, content: React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: Boolean(currentValue) }, content), headerLeft: " ", title: React.createElement(InsWidgetTitle, { ...props }) }));
};
